import { SearchSourceType } from '~/api/search';

export enum SearchFilterChip {
  ALL = 'all',
  CONTENT = 'content',
  LEARNING = 'learning',
  STORE = 'store',
}

export const CHIP_TYPE_MAP: Record<
  SearchFilterChip,
  SearchSourceType[] | undefined
> = {
  [SearchFilterChip.ALL]: undefined,
  [SearchFilterChip.CONTENT]: [SearchSourceType.CONTENT],
  [SearchFilterChip.LEARNING]: [
    SearchSourceType.CURRICULUM,
    SearchSourceType.MODULE,
    SearchSourceType.ACTIVITY,
  ],
  [SearchFilterChip.STORE]: [SearchSourceType.PRODUCT],
};

const NON_STORE_TYPES = Object.values(SearchSourceType).filter(
  (type) => type !== SearchSourceType.PRODUCT,
);

export const getSearchTypes = (
  chip: SearchFilterChip,
  isStoreEnabled: boolean,
): SearchSourceType[] | undefined => {
  if (chip === SearchFilterChip.ALL) {
    return isStoreEnabled ? undefined : NON_STORE_TYPES;
  }
  return CHIP_TYPE_MAP[chip];
};

/** Query param that opens a store product quick view over the results grid. */
export const SEARCH_PREVIEW_PARAM = 'preview';

export const SEARCH_SHARED_PARAM = 'shared';

export const SEARCH_PATH = '/search';

export const SHARED_SEARCH_PATH = '/search/shared';
